import SystemStore from './SystemStore.js';
import BaseFirebaseStore from './BaseFirebaseStore.js';

/**
 * @class Returns a new SystemStore class that is used to access the various bins of a Device's information
 **/
export default class RootStore extends BaseFirebaseStore {
  /**
   * @function Creates a DeviceStore for the system's device
   * @param dev either th id of the device, or a device object that contains an id field
   **/
  systemStore(sys) {
    const id = typeof sys === 'string' ? sys : sys && sys.id;
    if (id == null) {
      return null;
    }
    return super.child(id, SystemStore);
  }
}